import React, { useState } from 'react';
import { TextField, Button, Typography, Box, CircularProgress } from '@mui/material';
import { useAuth } from '@/lib/firebase/auth'; 
import { useNavigate } from 'react-router-dom';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const { signup, sendVerificationEmail } = useAuth(); 
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);

    if (password !== passwordConfirm) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      const newUser = await signup({ email, password });
      await sendVerificationEmail(newUser);
      navigate('/'); // Redirect to the dashboard after signup
    } catch (error) {
      // Check for specific Firebase error and set a custom message
      if (error.message.includes("Unauthorized email domain")) {
        setError('Unauthorized');
      } else {
        setError(error.message);
      }
      setLoading(false); // Reset loading state if there's an error
    }
  };

  return (
    <Box p={3} borderRadius={4} maxWidth={420} boxShadow={3} mx="auto" mt={8}>
      <Typography variant="h4" align="center" mb={3}>Sign Up</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (e.target.value) setShowPasswordConfirm(true); // Show confirm field when password is typed
          }}
        />
        {showPasswordConfirm && (
          <TextField
            label="Confirm Password"
            type="password"
            fullWidth
            margin="normal"
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
          />
        )}
        {error && <Typography color="error" variant="body2">{error}</Typography>}

        <Box mt={2} display="flex" justifyContent="center">
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={!password || password !== passwordConfirm || loading} // Disable if passwords don't match or loading
            >
              Sign Up
            </Button>
          )}
        </Box>
      </form>
    </Box>
  );
};

export default Signup;
